import React, { useState } from 'react';
import { map } from 'lodash';
import { TPagination } from 'modules/types';
import { Dropdown, Menu, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons/lib';

type TOrderingButtonProps = {
  pagination: TPagination;
  reloadPage: (page: Partial<TPagination>) => void;
  orderingList: { [key: string]: string };
  defaultKey: string;
  selected: string;
  setSelected: (x: any) => void;
};

const ResettableOrderingButton = ({
  pagination,
  reloadPage,
  orderingList,
  defaultKey,
  selected,
  setSelected,
}: TOrderingButtonProps) => {
  function handleOrdering(event: any) {
    reloadPage({
      current: 1,
      pageSize: pagination.pageSize,
      ordering: event.key,
    });
    setSelected(orderingList[event.key]);
  }

  return (
    <Dropdown
      overlay={
        <Menu onClick={handleOrdering}>
          {map(Object.keys(orderingList), (elem) => (
            <Menu.Item key={elem}>{orderingList[elem]}</Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button style={{ marginLeft: '5px' }} className='small-btn'>
        {selected}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default ResettableOrderingButton;
